export default {
    init() {
        this.productImgUpload();
        this.dragAndDropImgUpload();
        this.deleteImgFromList();
    },

    productImgUpload(){
        const self = this;
        let fileTypes = ['jpg', 'jpeg', 'png', 'pdf', 'docx', 'doc'];
        let maxAllowedSize = 16 * 1024 * 1024;
        let wrongFile = $('.product-photo-upload-wrap--upload-row .wrong-file-type');
        let uploadArea = $('.product-photo-upload-wrap--upload-box');
        let filesList = $('.product-photo-upload-wrap--list');
        let importFileInput = $('.product-field-file');

        importFileInput.on('change', function () {
            let importParent = $(this).parent().parent();
            let wrongFile = importParent.find('.wrong-file-type');
            let uploadArea = importParent.find('.form-photo-upload-wrap--upload-box');
            let filesList = importParent.find('.product-photo-upload-wrap--list');
            
            if ($(this)[0].files.length > 0) {
                uploadArea.removeClass('invalid');
                let filesAllowed = [];
                let countInvalid = false;
                let files = $(this)[0].files;

                for (let i = 0; i < files.length; i++) {
                    if(files[i].size < maxAllowedSize) {
                        let extension = files[i].name.split('.').pop().toLowerCase();
                        let isSuccess = fileTypes.indexOf(extension) > -1;
                        if (isSuccess) {
                            filesAllowed.push(files[i]);
                        } else {
                            countInvalid = true;
                        }
                    } else{
                        countInvalid = true;
                    }
                }

                // use for multiple files
                // for (let i = 0; i < filesAllowed.length; i++ ) {
                //     let numberOfChildren = filesList.children().length;
                //     if(numberOfChildren < 30) {
                //         filesList.append(`
                //         <li class="item">${filesAllowed[i].name}<span data-name="${filesAllowed[i].name}"></span></li>
                //     `);
                //     }
                // }

                if(filesAllowed.length > 0){
                    filesList.empty();
                    filesList.append(`
                        <li class="item">${filesAllowed[filesAllowed.length-1].name}<span data-name="${filesAllowed[filesAllowed.length-1].name}"></span></li>
                    `);
                }

                if(countInvalid == true ){
                    uploadArea.addClass('invalid');
                    wrongFile.slideDown(300);
                } else {
                    wrongFile.slideUp(300);
                    uploadArea.removeClass('invalid');
                }
            }
        });
    },

    dragAndDropImgUpload() {
        const self = this;
        let fileTypes = ['jpg', 'jpeg', 'png'];
        let maxAllowedSize = 16 * 1024 * 1024;
        let wrongFile = $('.product-photo-upload-wrap--upload-row .wrong-file-type');
        let uploadArea = $('.product-photo-upload-wrap--upload-box');
        let filesList = $('.product-photo-upload-wrap--list');
        let explorerCheck = false;
        let safariCheck = false;

        if (navigator.userAgent.indexOf('Trident/') !== -1) {
            explorerCheck = true;
        } else {
            explorerCheck = false;
        }

        if (navigator.userAgent.indexOf('Safari') !== -1 && navigator.userAgent.indexOf('Chrome') === -1) {
            safariCheck = true;
        } else {
            safariCheck = false;
        }

        if (!safariCheck && !explorerCheck) {
            // Drag and drop
            window.addEventListener('dragenter', preventDefaults, false);
            window.addEventListener('dragleave', preventDefaults, false);
            window.addEventListener('dragover', preventDefaults, false);
            window.addEventListener('drop', preventDefaults, false);

            window.addEventListener('dragover', highlight, false);
            window.addEventListener('drop', dropFiles, false);
        } else {
        }

        function preventDefaults(e) {
            e.preventDefault();
            e.stopPropagation();
        }

        function highlight() {
                $('.drag-and-drop-toggle').show();
        }

        function dropFiles(e) {
                $('.drag-and-drop-toggle').hide();

                //If delete previous import
                //filesList.empty();

                let filesAllowed = [];
                let files = e.dataTransfer.files;
                let countInvalid = false;

                for (let i = 0; i < files.length; i++) {
                    if(files[i].size < maxAllowedSize) {
                        let extension = files[i].name.split('.').pop().toLowerCase();
                        let isSuccess = fileTypes.indexOf(extension) > -1;
                        if (isSuccess) {
                            filesAllowed.push(files[i]);
                        } else {
                            countInvalid = true;
                        }
                    } else{
                        countInvalid = true;
                    }
                }

                if(countInvalid == true ){
                    uploadArea.addClass('invalid');
                    wrongFile.slideDown(300);
                } else {
                    wrongFile.slideUp(300);
                    uploadArea.removeClass('invalid');
                }

                generateFileList(filesAllowed);
                document.querySelector('.product-img-file').files = new FileListItem(filesAllowed);
        }

        function generateFileList(files) {
            for (let file of files) {
                    let numberOfChildren = filesList.children().length;
                    if(numberOfChildren < 30) {
                    filesList.append(`<div class="item">"${file.name}" <span data-name="${file.name}"></span></div>`);
                }
            }
        }

        function FileListItem(a) {
            a = [].slice.call(Array.isArray(a) ? a : arguments)
            for (var c, b = c = a.length, d = !0; b-- && d;) d = a[b] instanceof File
            if (!d) throw new TypeError("expected argument to FileList is File or array of File objects")
            for (b = (new ClipboardEvent("")).clipboardData || new DataTransfer; c--;) b.items.add(a[c])
            return b.files
        }
    },

    deleteImgFromList() {
        $('body').on('click', '.product-photo-upload-wrap--list .item span' ,function () {
            $(this).parent().remove();
        });
    },
}